import React from "react";

const Register = () => {
  const data = [
    {
      tt: 1,
      name: "MD3",
      price: "3.000đ/ngày",
      register: "DK D3, DK V",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 2,
      name: "MVD10",
      price: "5.000đ/ngày",
      register: "DK MVD10, DK M",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 3,
      name: "Gói ngày",
      price: "500đ/ngày",
      register: "DKN",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 4,
      name: "Gói tuần",
      price: (
        <>
          2.000đ/tuần
          <br />
          <span className="text-sm ">
            (TKC không đủ trừ cước bậc thang:
            <br />
            1.000đ/3ngày, 500đ/ngày)
          </span>
        </>
      ),
      register: "DKN",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 5,
      name: "Gói tháng",
      price: (
        <>
          10.000đ/tháng
          <br />
          <span className="text-sm">
            (TKC không đủ trừ cước bậc thang:
            <br />
            5.000đ/2tuần, 2.000đ/tuần,
            <br />
            1.000đ/3ngày, 500đ/ngày)
          </span>
        </>
      ),
      register: "DKT",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 6,
      name: "MCA Plus",
      price: (
        <>
          Tính cước 6 tin SMS đầu tiên trong ngày giá 500đ/lượt khi nhận bản tin
          cước gọi nhỡ qua SMS
        </>
      ),
      register: "DKP",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 7,
      name: "Gói Miễn phí",
      price: "0đ",
      register: "DK MCA",
      cancel: "HUY",
      short: "1020",
    },
    {
      tt: 8,
      name: "Cước gửi USSD đến đầu số 1020",
      price: "Miễn phí",
      register: "",
      cancel: "",
      short: "1020",
    },
    {
      tt: 9,
      name: "Cước nhận bản tin thông báo cuộc gọi nhỡ",
      price: "Miễn phí",
      register: "",
      cancel: "",
      short: "1020",
    },
    {
      tt: 10,
      name: "Cước gọi đến tổng đài 0241020 và 0241020xx để nghe lời nhắn thoại",
      price: "Miễn phí",
      register: "",
      cancel: "",
      short: "1020",
    },
    {
      tt: 11,
      name: "Cước phí của thuê bao A để lưu lại lời nhắn thoại: tính từ sau khi nghe hết lời hướng dẫn của tổng đài",
      price: "Miễn phí",
      register: "",
      cancel: "",
      short: "1020",
    },
    {
      tt: 12,
      name: "Cước Data",
      price: "Miễn phí",
      register: "",
      cancel: "",
      short: "1020",
    },
  ];
  const data1 = [
    {
      name: "MD3",
      register: "*1020*5#",
      cancel: "*1020*0#",
      short: "1020",
    },
    {
      name: "MVD10",
      register: "*1020*6#",
      cancel: "*1020*0#",
      short: "1020",
    },
    {
      name: "MD30",
      register: "*1020*7#",
      cancel: "*1020*0#",
      short: "1020",
    },
  ];
  return (
    <div className="w-full px-4 lg:px-0 lg:w-4/5 mx-auto py-4">
      <h1 className="font-bold text-base lg:text-[30px] text-[#1F7ED0] lg:mb-6 lg:mt-12 text-center lg:text-left">
        HƯỚNG DẪN ĐĂNG KÝ DỊCH VỤ
      </h1>

      <div className="flex flex-col lg:gap-6">
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col  bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                1. Cách đăng ký, hủy dịch vụ qua kênh SMS.
              </h3>
            </div>

            <div className="py-4 lg:px-4">
              <div className="overflow-x-auto hidden lg:block">
                <table className="w-full border border-[#ACABAB] text-sm">
                  <thead className="bg-[#1F7ED040]">
                    <tr>
                      <th className="border px-2 py-2">TT</th>
                      <th className="border px-3 py-2">Tên gói</th>
                      <th className="border px-3 py-2">Giá cước</th>
                      <th className="border px-3 py-2">Cú pháp đăng ký</th>
                      <th className="border px-3 py-2">Cú pháp Hủy</th>
                      <th className="border px-3 py-2">Đầu số</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.map((item, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="border px-2 py-2 text-center">
                          {item.tt}
                        </td>

                        <td className="border px-3 py-2 text-blue-600 font-semibold">
                          {item.name}
                        </td>

                        <td className="border px-3 py-2">{item.price}</td>

                        <td className="border px-3 py-2 text-pink-600 font-semibold">
                          {item.register}
                        </td>

                        <td className="border px-3 py-2 text-pink-600 font-semibold">
                          {item.cancel}
                        </td>

                        <td className="border px-3 py-2 text-pink-600 font-semibold text-center">
                          {item.short}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* MOBILE VIEW */}
              <div className="lg:hidden pb-4">
                {data.map((item, idx) => (
                  <div key={idx} className="last:border-b-2 last:border-b-[#1F7ED0] rounded overflow-hidden shadow-sm">
                    <div className="flex bg-[#E5E5E5]">
                      <div className="w-10 bg-[linear-gradient(180deg,_#42DDA5_0%,_#1F7ED0_100%)] text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
                        {item.tt}
                      </div>

                      <div className="px-3 py-2.5 font-bold text-sm text-[#34404B] flex items-center">
                        {item.register && " Cú pháp:"}
                        <span
                          className={`${item.register ? "text-[#E91E8C]" : "text-[#34404B]"}  font-bold ml-1`}
                        >
                          {item.name}
                        </span>
                      </div>
                    </div>

                    <div className="border-x-2 border-x-[#1F7ED0] ">
                      <div className="bg-white divide-y divide-gray-200 ml-10 ">
                        {item.register && (
                          <div className="px-3 py-3">
                            <div className="text-sm text-gray-900">
                              Cú pháp đăng ký:
                            </div>
                            <div className="text-sm mt-0.5">
                              <span className="text-[#E91E8C] font-bold">
                                {item.register}
                              </span>{" "}
                              <span className="text-gray-900">gửi đầu số</span>{" "}
                              <span className="text-[#E91E8C] font-bold">
                                {item.short}
                              </span>
                            </div>
                          </div>
                        )}

                        {item.cancel && (
                          <div className="px-3 py-3">
                            <div className="text-sm text-gray-900">
                              Cú pháp Hủy:
                            </div>
                            <div className="text-sm mt-0.5">
                              <span className="text-[#E91E8C] font-bold">
                                {item.cancel}
                              </span>{" "}
                              <span className="text-gray-900">gửi đầu số</span>{" "}
                              <span className="text-[#E91E8C] font-bold">
                                {item.short}
                              </span>
                            </div>
                          </div>
                        )}

                        <div className="px-3 py-3 text-sm">
                          <span className="text-gray-900">Giá cước:</span>{" "}
                          <span className="text-[#34404B] font-bold">
                            {item.price}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <ul className="list-disc list-inside space-y-2 text-sm">
                <li>
                  Khách hàng không đăng ký đồng thời với các gói cước khác của
                  dịch vụ MCA trừ gói cước MCA Free.
                </li>
                <li>
                  <b>Với gói MD30:</b> Khách hàng được miễn phí 8GB data mỗi
                  tháng, data cộng thêm sẽ được cộng vào tài khoản data khuyến
                  mại tương ứng. Sau khi hết số data miễn phí, khách hàng sử
                  dụng data theo gói data chính đang đăng ký sử dụng hoặc khách
                  hàng không có gói data thì sẽ tính cước data M0. Khách hàng
                  không sử dụng hết data của chu kỳ trước không được cộng dồn
                  sang chu kỳ sau.
                </li>
                <li>
                  <b>Với gói MD3:</b> Khách hàng được miễn phí 300MB data mỗi
                  ngày, data cộng thêm sẽ được cộng vào tài khoản data khuyến
                  mại tương ứng. Sau khi hết số data miễn phí, khách hàng sử
                  dụng data theo gói data chính đang đăng ký sử dụng hoặc khách
                  hàng không có gói data thì sẽ tính cước data M0. Khách hàng
                  không sử dụng hết data của ngày hôm trước không được cộng dồn
                  sang ngày hôm sau.
                </li>
                <li>
                  <b>Với gói MVD10:</b> Khách hàng được miễn phí 10 phút thoại
                  nội mạng và 200MB data mỗi ngày. Sau khi hết số phút miễn phí,
                  hệ thống sẽ tính theo cước thoại thông thường. Sau khi hết số
                  data miễn phí, khách hàng sử dụng data theo gói data chính
                  đang đăng ký sử dụng. Khách hàng không sử dụng hết thoại/ data
                  của ngày hôm trước không được cộng dồn sang ngày hôm sau.
                </li>
                <li>
                  Toàn bộ cước của dịch vụ sẽ được ghi vào hóa đơn cước tháng
                  (đối với thuê bao trả sau) và trừ vào tài khoản chính (đối với
                  thuê bao trả trước).
                </li>
                <li>Toàn bộ giá cước trên đã bao gồm VAT.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                2. Cách đăng ký/hủy qua kênh USSD
              </h3>
            </div>

            <div className="py-4 lg:px-4">
              <div className="hidden lg:block overflow-x-auto">
                <table className="w-full border border-gray-300 text-sm">
                  <thead className="bg-blue-100">
                    <tr>
                      <th className="border px-4 py-2 text-left">Tên gói</th>
                      <th className="border px-4 py-2 text-left">
                        Cú pháp đăng ký
                      </th>
                      <th className="border px-4 py-2 text-left">
                        Cú pháp Hủy
                      </th>
                      <th className="border px-4 py-2 text-left">Đầu số</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data1.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="border px-4 py-2 text-blue-600 font-semibold">
                          {item.name}
                        </td>
                        <td className="border px-4 py-2">{item.register}</td>
                        <td className="border px-4 py-2">{item.cancel}</td>
                        <td className="border px-4 py-2">{item.short}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* DESKTOP TABLE */}
              {/* MOBILE CARD */}
              <div className="lg:hidden">
                {data1.map((item, index) => (
                  <div
                    key={index}
                    className=" rounded overflow-hidden last:border-b-2 last:border-b-[#1F7ED0]"
                  >
                    {/* HEADER */}
                    <div className="flex bg-[#E5E5E5]">
                      <div className="w-10 bg-[linear-gradient(180deg,_#42DDA5_0%,_#1F7ED0_100%)] text-white flex items-center justify-center font-bold">
                        {index + 1}
                      </div>

                      <div className="px-3 py-2.5 text-sm">
                        Cú pháp:{" "}
                        <span className="text-[#E91E8C] font-bold">
                          {item.name}
                        </span>
                      </div>
                    </div>

                    {/* BODY */}
                    <div className = "border-x-2 border-x-[#1F7ED0] ">
                    <div className="bg-white divide-y divide-gray-200 ml-10">
                      <div className="px-3 py-3 text-sm">
                        <span className="text-[#34404B]">Cú pháp đăng ký:</span>
                        <div className="mt-0.5">
                          <span className="text-[#E91E8C] font-bold">
                            {item.register}
                          </span>
                        </div>
                      </div>

                      <div className="px-3 py-3 text-sm">
                        <span className="text-[#34404B]">Cú pháp hủy:</span>
                        <div className="mt-0.5">
                          <span className="text-[#E91E8C] font-bold">
                            {item.cancel}
                          </span>
                        </div>
                      </div>

                      
                    </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
